import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import i18n from '../../../../../../../i18';
import { MessageQuestionCustomLinearIcon } from '../../../../../../../icons-lib';
import CheckboxGroup from '../../../../../../../components/checkbox-group';

export const CheckboxesField = ({
    field,
    data,
    // additionalData,
    onChange
}) => {
    const { id, label, tipText, secondaryLabel, options } = field;
    const translatedLabel = i18n.t(`columns.${label}`);
    const secondaryLabelTranslated = i18n.t(`text.${secondaryLabel}`);

    return (
        <Box sx={{ mb: 2 }}>
            <Box display={'flex'} alignItems={'center'}>
                <Typography variant="title1">{translatedLabel}</Typography>
                {tipText && (
                    <Tooltip title={tipText} placement="top">
                        <IconButton size="small">
                            <MessageQuestionCustomLinearIcon
                                sx={{ fontSize: '1rem' }}
                            />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            {secondaryLabel && (
                <Typography variant="body2" color="textSecondary">
                    {secondaryLabelTranslated}
                </Typography>
            )}
            <CheckboxGroup 
                options={options} 
                selectedValues={data || []} 
                onChange={(value) => onChange(id, value)} 
            />
        </Box>
    );
};
